import React, { useState } from 'react';
import { Controller } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import { getJaecooSiteLang } from '../../../../../utils/cookie';
import styles from './CustomPhoneInputField.module.scss';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

// 获取当前语言
const getCurrentLanguage = (location) => {
  const cookieLang = getJaecooSiteLang();
  if (cookieLang) return cookieLang;

  const path = location.pathname;
  if (path.startsWith('/en')) return 'en';
  if (path.startsWith('/nl')) return 'nl';
  if (path.startsWith('/be')) return 'be';
  return 'en';
};

// 语格式：只支持手机号，32开头，保留32后一个空格
const formatPhoneNL = (digits) => {
  let v = digits.replace(/\D/g, '');
  if (!v) return '';

  // 确保以 32 开头（国家代码）
  if (v[0] !== '3' || v[1] !== '2') {
    // 如果以 0 开头，去掉 0 再添加 32
    if (v[0] === '0') {
      v = '32' + v.slice(1);
    } else {
      v = '32' + v;
    }
  }

  // 格式化为 32 61234567 (32后一个空格，后面无空格)
  if (v.length <= 2) {
    return '+' + v;
  } else {
    return '+' + v.slice(0, 2) + ' ' + v.slice(2);
  }
};

// 统一使用格式（英文版和版一致）
const formatPhone = (digits, language) => {
  // 无论什么语言都使用格式
  return formatPhoneNL(digits);
};

const CustomPhoneInputField = ({ placeholder, control, name, error, trigger }) => {
  const location = useLocation();
  const currentLang = getCurrentLanguage(location);

  return (
    <div className={styles.phoneNumberInputContainer}>
      <Controller
        name={name}
        control={control}
        render={({ field: { value, onChange, onBlur, ref } }) => {
          const displayValue = formatPhone(value || '', currentLang);
          // 统一使用格式的输入处理逻辑
          const handleChange = (e) => {
            // 无论什么语言都使用格式：只支持手机号，32开头，总共11位数字
            const justDigits = e.target.value.replace(/\D/g, '');
            const raw = justDigits.slice(0, 10);
            onChange(raw);
          };

          // 统一使用格式的 pattern
          const getPattern = () => {
            // 无论什么语言都使用格式：32 612345678 (32后一个空格，10位数字)
            return '\\d{2}\\s\\d{9}';
          };

          // 处理输入逻辑
          const handleChange2 = (phone, onChange, countryData) => {
            let digits = phone.replace(/\D/g, '');

            // 如果是，强制 32 开头 + 最多 8 位
            if (countryData?.countryCode === 'be') {
              if (!digits.startsWith('32')) {
                digits = '32' + digits.replace(/^0+/, '');
              }
              digits = digits.slice(0, 10); // 32 (2位) + 8 位手机号
            }
            onChange(digits);
          };

          // 将纯数字格式化为 +32 612345678
          const formatDisplayValue = (digits) => {
            if (!digits) return '+32 ';
            if (!digits.startsWith('32')) return '+32 ';

            const cc = digits.slice(0, 2); // 国家码 32
            const number = digits.slice(2); // 手机号部分
            return `+${cc} ${number}`;
          };

          const phoneCtryList = {
            nl: ['be', 'lu', 'nl', 'fr', 'es', 'it', 'ch', 'gb', 'de'],
            en: ['be', 'lu', 'nl', 'fr', 'es', 'it', 'ch', 'gb', 'de'],
            fr: ['be', 'lu', 'nl', 'fr', 'es', 'it', 'ch', 'gb', 'de'],
          };

          return (
            <PhoneInput
              onlyCountries={phoneCtryList[currentLang]}
              country={'be'} // 默认
              countryCodeEditable={false}
              disableDropdown={false} // 仍显示国旗选择，但只有
              placeholder={placeholder}
              value={value || ''}
              onChange={(phone, countryData) => {
                // 如果切换到，检查是否超长 → 截断
                if (countryData?.countryCode === 'be') {
                  const digits = (phone || '').replace(/\D/g, '').slice(0, 11);
                  onChange(digits);
                } else {
                  onChange((phone || '').replace(/\D/g, ''));
                }
              }}
              onBlur={() => {
                trigger(name);
                onBlur();
              }}
              inputProps={{
                autoComplete: 'tel',
                type: 'tel',
                name,
                ref,
                ...(value?.startsWith('32') // 只有时加 maxLength
                  ? { maxLength: 16 } // +32 + 空格 + 9 位手机号
                  : {}),
              }}
              className={styles.phoneInput2Box}
              inputClass={styles.phoneInput2}
              buttonClass={styles.flagDropdownBtn}
              masks={{}}
              enableAreaCodes={false}
              enableTerritories={false}
              disableCountryCode={false}
            />
          );
        }}
      />
      {error && <p className={styles.errorText}>{error}</p>}
    </div>
  );
};

export default CustomPhoneInputField;
